<div class="one3d-test-drive-form-wrapper">
  <div class="one3d-login-popup-wrapper">
    <span (click)="close()" class="one3d-td-form-close">
      <img src="assets/icons/close.svg" alt="close" />
    </span>
    <div class="otdf-car">
      <img [src]="
          modelSelected?.image_url
            ? modelSelected.image_url
            : 'assets/img/one3d-test-drive-car.png'
        " />
    </div>
    <!--PHONE/EMAIL starts-->
    <div *ngIf="currentStep === 1 && screenOne" class="otdf-steps">
      <div class="one3d-login-header">
        <h4 class="one3d-login-header-title ion-text-center">
          Book your {{ modelSelected?.model_name }} Test Drive Today!
        </h4>
      </div>
    </div>
    <div class="otd-form">
      <form [formGroup]="form">
        <div *ngIf="currentStep === 1 && screenOne">
          <p class="one3d-login-header-para">FIRST NAME</p>
          <div class="one3d-login-input-number-row">
            <input class="one3d-login-input-number one3d-full-width" type="text" formControlName="firstName"
              placeholder="Enter First Name" (blur)="onBlur('firstName')" />
          </div>
          <p *ngIf="
              form.get('firstName').invalid && form.get('firstName').touched
            " class="one3d-login-input-error">
            <small *ngIf="form.get('firstName').hasError('required')">Please enter a valid First Name</small>
            <small *ngIf="form.get('firstName').hasError('pattern')">
              First name must be 2-40 characters and contain only letters,
              spaces, and hyphens.
            </small>
          </p>
          <p class="one3d-login-header-para">LAST NAME</p>
          <div class="one3d-login-input-number-row">
            <input class="one3d-login-input-number one3d-full-width" type="text" formControlName="lastName"
              placeholder="Enter Last Name" (blur)="onBlur('lastName')" />
          </div>
          <p *ngIf="form.get('lastName').invalid && form.get('lastName').touched" class="one3d-login-input-error">
            <small *ngIf="form.get('lastName').hasError('required')">Please enter a valid Last Name</small>
            <small *ngIf="form.get('lastName').hasError('pattern')">
              Last name must be 2-40 characters and contain only letters,
              spaces, and hyphens.
            </small>
          </p>
          <p class="one3d-login-header-para">
            PHONE
            <span class="one3d-phone-input"> (eg: 0XXX-XXX-XXX) </span>
          </p>
          <div class="one3d-login-input-number-row one3d-test-drive-phone-row">
            <div class="country-code">
              <span class="country-code-text"> +61 </span>
            </div>
            <div class="phone-field-new">
              <input class="one3d-login-input-number one3d-full-width" type="tel" formControlName="phone"
                placeholder="Enter Phone Number" maxlength="10" (blur)="onBlur('phone')" />
            </div>
          </div>
          <p *ngIf="form.get('phone').invalid && form.get('phone').touched" class="one3d-login-input-error">
            <small *ngIf="form.get('phone').hasError('pattern')">Phone number must be a valid number.</small>
            <small *ngIf="form.get('phone').hasError('required')">Please enter Phone Number</small>
          </p>
          <button class="one3d-login-bottom-btn one3d-login-submit-btn" [disabled]="!isFormValid" (click)="nextStep()">
            NEXT
          </button>
        </div>
        <div *ngIf="currentStep === 2 && screenTwo">
          <p class="one3d-login-header-para">EMAIL</p>
          <div class="one3d-login-input-number-row">
            <input class="one3d-login-input-number one3d-full-width" type="email" formControlName="email"
              placeholder="Enter your Email ID" (blur)="onBlur('email')" />
          </div>
          <p *ngIf="form.get('email').invalid && form.get('email').touched" class="one3d-login-input-error">
            Please enter a valid Email ID
          </p>
          <div class="one3d-email-description-wrap">
            <p class="one3d-email-description">
              Disclaimer: Stellantis (Australia and New Zealand) Pty Ltd
              (Stellantis Australia) respects your privacy. We will only use the
              information you provide for the purposes of processing and
              fulfilling your request or enquiry.
              <span class="see-more-text" (click)="toggleText()">{{
                isExpanded ? "See Less" : "See More"
                }}</span>
            </p>
            <p class="one3d-email-description-extra-text" id="extraText">
              We may disclose your information to an authorised dealer, our
              related companies and/or third parties associated with us for
              these purposes. If you have consented on this form, we may also
              use and disclose your information to send you marketing material
              about products and services which may be of interest to you. If
              you have asked to be contacted by a dealer, we may also disclose
              your information to an dealer for that purpose. Our
              <a href="https://www.leapmotor.net/au/privacy-policy" target="_blank">Privacy Policy</a>
              contains further details regarding how you can access or correct
              information we hold about you, how you can make a privacy related
              complaint, how that complaint will be dealt with and the extent to
              which your information may be disclosed to overseas recipients.
            </p>
          </div>
          <div class="one3d-checkbox-email-container">
            <label class="new-label-checkbox-container">
              I wish to receive special offers, events and news from Leapmotor
              Australia
              <input type="checkbox" formControlName="checkbox" />
              <span class="checkmark"></span>
            </label>
          </div>
          <button class="one3d-login-bottom-btn one3d-login-submit-btn" [disabled]="!isFormValid" (click)="finish()">
            FINISH
          </button>
        </div>
      </form>
    </div>
    <!--SUCCESS starts-->
    <div class="otdf-steps" *ngIf="screenThree">
      <div class="otdf-check-icon ion-text-center">
        <img src="assets/img/icons/one3d-green-tick.png" />
      </div>
      <div class="one3d-login-header">
        <h4 class="one3d-login-header-title ion-text-center fw-600">
          Your Test Drive Request has been accepted!
        </h4>
        <p class="one3d-login-header-para mb-0 ion-text-center">
          We will reach out to you within 24 hours.
        </p>
      </div>
    </div>
    <!--SUCCESS ends-->
    <div class="bottom-dots">
      <span [ngClass]="{ active: currentStep === 1 && screenOne }"></span>
      <span [ngClass]="{ active: (currentStep === 2 && screenTwo) || screenThree }"></span>
    </div>
    <!-- iframe  -->
    <!-- <iframe *ngIf="iFrame" src="https://www.jeep.com.au/schedule-a-test-drive/thank-you.html?vehicle=grand-cherokee"
      width="100%" height="100%" frameborder="0" allowfullscreen>
    </iframe> -->
  </div>
</div>